export default async function init() {
  const elements = document.querySelectorAll('.video-loop');

  const { default: VideoLoop } = await import(/* webpackChunkName: "video-loop" */ './video-loop');

  elements.forEach((element) => new VideoLoop(element));
}
